// import React, { useState, useEffect, forwardRef, useImperativeHandle } from "react";
// import { Box, Typography, TextField, Button, MenuItem, Select, FormControl, InputLabel, Paper, Divider, Grid, CircularProgress } from '@mui/material';
// import { styled } from '@mui/system';
// import { useTheme } from "@mui/material";

// const StyledPaper = styled(Paper)(({ theme }) => ({
//   padding: theme.spacing(3),
//   margin: theme.spacing(2, 0),
//   borderRadius: theme.shape.borderRadius * 2,
//   boxShadow: theme.shadows[3],
// }));

// const StyledButton = styled(Button)(({ theme }) => ({
//   marginTop: theme.spacing(2),
//   padding: theme.spacing(1.5),
//   fontWeight: 'bold',
//   fontSize: '1rem',
// }));

// const Tab_PayrollPage = forwardRef((props, ref) => {
//   const theme = useTheme();
//   const { employeeId } = props;
//   const [earnings, setEarnings] = useState([]);
//   const [deductions, setDeductions] = useState([]);
//   const [selectedEmployee, setSelectedEmployee] = useState("");
//   const [selectedDate, setSelectedDate] = useState("");
//   const [earningValues, setEarningValues] = useState({});
//   const [deductionValues, setDeductionValues] = useState({});
//   const [existingPayroll, setExistingPayroll] = useState(null);
//   const [isPreview, setIsPreview] = useState(false);
//   const [isLoading, setIsLoading] = useState(false);
//   const [defaultCTCEarnings, setDefaultCTCEarnings] = useState([]);
//   const [defaultCTCDeductions, setDefaultCTCDeductions] = useState([]);

//   useEffect(() => {
//     if (employeeId) {
//       setSelectedEmployee(employeeId);
//     }

//     // Set current month as default date
//     const currentDate = new Date();
//     const currentYearMonth = `${currentDate.getFullYear()}-${String(currentDate.getMonth() + 1).padStart(2, '0')}`;
//     setSelectedDate(currentYearMonth);

//     fetchCTCDetails();
//   }, [employeeId]);

//   useEffect(() => {
//     if (selectedEmployee && selectedDate) {
//       fetchPayrollData();
//     } else {
//       setExistingPayroll(null);
//       setEarnings(defaultCTCEarnings);
//       setDeductions(defaultCTCDeductions);
//       setEarningValues({});
//       setDeductionValues({});
//     }
//   }, [selectedEmployee, selectedDate]);

//   const fetchPayrollData = async () => {
//     try {
//       setIsLoading(true);
//       const response = await fetch(`${process.env.REACT_APP_BACKEND_URL_HRM}/get-payroll`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify({
//           email_id: selectedEmployee,
//           date: selectedDate,
//         }),
//       });

//       const data = await response.json();
//       if (response.ok && data.payroll_data) {
//         setExistingPayroll(data.payroll_data);
//         const payrollEarnings = Object.keys(data.payroll_data.earnings || {});
//         const payrollDeductions = Object.keys(data.payroll_data.deductions || {});

//         setEarnings(payrollEarnings);
//         setDeductions(payrollDeductions);
//         setEarningValues(data.payroll_data.earnings || {});
//         setDeductionValues(data.payroll_data.deductions || {});
//       } else {
//         setExistingPayroll(null);
//         setEarnings(defaultCTCEarnings);
//         setDeductions(defaultCTCDeductions);
//         setEarningValues({});
//         setDeductionValues({});
//       }
//     } catch (error) {
//       console.error("Error fetching payroll data:", error);
//       setExistingPayroll(null);
//       setEarnings(defaultCTCEarnings);
//       setDeductions(defaultCTCDeductions);
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const fetchCTCDetails = async () => {
//     try {
//       const response = await fetch(`${process.env.REACT_APP_BACKEND_URL_HRM}/get_ctc`);
//       const data = await response.json();
//       if (response.ok) {
//         setEarnings(data.earnings || []);
//         setDeductions(data.deductions || []);
//         setDefaultCTCEarnings(data.earnings || []);
//         setDefaultCTCDeductions(data.deductions || []);
//       } else {
//         alert(data.error);
//       }
//     } catch (error) {
//       console.error("Error fetching CTC details:", error);
//       alert("Failed to load CTC details.");
//     }
//   };

//   const handleEarningChange = (field, value) => {
//     setEarningValues((prev) => ({ ...prev, [field]: Number(value) }));
//     if (props.handleFieldChange) {
//       props.handleFieldChange("payrollDetails", "earnings", { ...earningValues, [field]: Number(value) });
//     }
//   };

//   const handleDeductionChange = (field, value) => {
//     setDeductionValues((prev) => ({ ...prev, [field]: Number(value) }));
//     if (props.handleFieldChange) {
//       props.handleFieldChange("payrollDetails", "deductions", { ...deductionValues, [field]: Number(value) });
//     }
//   };

//   const handlePreview = async () => {
//     if (!selectedEmployee || !selectedDate) {
//       alert("Please select an employee and date.");
//       return;
//     }

//     const payload = {
//       email_id: selectedEmployee,
//       date: selectedDate,
//       earnings: earningValues,
//       deductions: deductionValues,
//     };

//     try {
//       setIsLoading(true);
//       const response = await fetch(`${process.env.REACT_APP_BACKEND_URL_HRM}/preview-payroll`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify(payload),
//       });

//       const data = await response.json();
//       if (response.ok) {
//         setExistingPayroll(data);
//         setIsPreview(true);
//       } else {
//         alert("Error: " + data.error);
//       }
//     } catch (error) {
//       console.error("Error previewing payroll:", error);
//       alert("Failed to preview payroll.");
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   const handleSubmit = async () => {
//     if (!selectedEmployee || !selectedDate) {
//       alert("Please select an employee and date.");
//       return;
//     }

//     const payload = {
//       email_id: selectedEmployee,
//       selected_month: selectedDate,
//       earnings: earningValues,
//       deductions: deductionValues,
//       total_earnings: existingPayroll?.total_earnings || 0,
//       total_deductions: existingPayroll?.total_deductions || 0,
//       total_salary: existingPayroll?.total_salary || 0,
//       leave_summary: existingPayroll?.leave_summary || {},
//       total_leave_days: existingPayroll?.total_leave_days || 0,
//       actual_emergency_leave: existingPayroll?.actual_emergency_leave || 0,
//       actual_planned_leave: existingPayroll?.actual_planned_leave || 0,
//       subtracted_los_emergency_leave: existingPayroll?.subtracted_los_emergency_leave || 0,
//       subtracted_los_planned_leave: existingPayroll?.subtracted_los_planned_leave || 0,
//       one_day_salary: existingPayroll?.one_day_salary || 0,
//       LOSP: existingPayroll?.LOSP || 0,
//       LOSE: existingPayroll?.LOSE || 0,
//       total_los: existingPayroll?.total_los || 0,
//       LOP_DAYS: existingPayroll?.LOP_DAYS || 0,
//       actual_working_days: existingPayroll?.actual_working_days || 0,
//       num_days: existingPayroll?.num_days || 0,
//     };

//     try {
//       setIsLoading(true);
//       const response = await fetch(`${process.env.REACT_APP_BACKEND_URL_HRM}/store-payroll`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify(payload),
//       });

//       const data = await response.json();
//       if (response.ok) {
//         alert("Payroll data saved successfully!");
//         setIsPreview(false);
//         fetchPayrollData();
//       } else {
//         alert("Error: " + data.error);
//       }
//     } catch (error) {
//       console.error("Error submitting payroll:", error);
//       alert("Failed to submit payroll.");
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   useImperativeHandle(ref, () => ({
//     save: handleSubmit
//   }));

//   const renderPayrollDetails = () => {
//     if (!existingPayroll) return null;

//     return (
//       <StyledPaper elevation={3} style={{backgroundColor:"white", color:"black"}}>
//         <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', color: 'primary.main' }}>
//           Payroll Details
//         </Typography>
//         <Divider sx={{ my: 2 }} />

//         <Grid container spacing={3}>
//           <Grid item xs={12} md={6}>
//             <Typography variant="body1"><strong>Number of Days Paid:</strong> {existingPayroll.actual_working_days}</Typography>
//             <Typography variant="body1"><strong>Total days in month:</strong> {existingPayroll.num_days}</Typography>
//             <Typography variant="body1"><strong>LOP Days:</strong> {existingPayroll.LOP_DAYS}</Typography>
//             <Typography variant="body1"><strong>Total Leaves Taken:</strong> {existingPayroll.total_leave_days}</Typography>
//             <Typography variant="body1"><strong>Emergency Leaves Taken:</strong> {existingPayroll.leave_summary.EMERGENCY}</Typography>
//             <Typography variant="body1"><strong>Planned Leaves Taken:</strong> {existingPayroll.leave_summary.PLANNED}</Typography>
//           </Grid>
//           <Grid item xs={12} md={6}>
//             <Typography variant="body1"><strong>Leave Opening (Emergency):</strong> {existingPayroll.actual_emergency_leave}</Typography>
//             <Typography variant="body1"><strong>Leave Opening (Planned):</strong> {existingPayroll.actual_planned_leave}</Typography>
//             <Typography variant="body1"><strong>Leave Closing (Emergency):</strong> {existingPayroll.subtracted_los_emergency_leave}</Typography>
//             <Typography variant="body1"><strong>Leave Closing (Planned):</strong> {existingPayroll.subtracted_los_planned_leave}</Typography>
//           </Grid>
//         </Grid>

//         <Box sx={{ mt: 3, p: 2, backgroundColor: '#f5f5f5', borderRadius: 1 }}>
//           <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
//             Net Salary: ₹{existingPayroll.total_salary}
//           </Typography>
//         </Box>
//       </StyledPaper>
//     );
//   };

//   const renderPayrollForm = () => {
//     if (isPreview && existingPayroll) {
//       return (
//         <StyledPaper elevation={3} style={{backgroundColor:"white", color:"black"}}>
//           <Typography variant="h5" align="center" gutterBottom sx={{ fontWeight: 'bold', color: 'primary.main' }}>
//             Payroll Preview
//           </Typography>

//           {renderPayrollDetails()}

//           <Grid container spacing={3} sx={{ mt: 2 }}>
//             <Grid item xs={12} md={6}>
//               <Typography variant="h6" gutterBottom>Earnings</Typography>
//               {Object.entries(existingPayroll.earnings || {}).map(([key, value]) => (
//                 <Box key={key} display="flex" justifyContent="space-between" mb={1}>
//                   <Typography>{key}:</Typography>
//                   <Typography>₹{value}</Typography>
//                 </Box>
//               ))}
//               <Divider sx={{ my: 1 }} />
//               <Box display="flex" justifyContent="space-between" sx={{ fontWeight: 'bold' }}>
//                 <Typography>Total Earnings:</Typography>
//                 <Typography>₹{existingPayroll.total_earnings}</Typography>
//               </Box>
//             </Grid>

//             <Grid item xs={12} md={6}>
//               <Typography variant="h6" gutterBottom>Deductions</Typography>
//               {Object.entries(existingPayroll.deductions || {}).map(([key, value]) => (
//                 <Box key={key} display="flex" justifyContent="space-between" mb={1}>
//                   <Typography>{key}:</Typography>
//                   <Typography>₹{value}</Typography>
//                 </Box>
//               ))}
//               <Divider sx={{ my: 1 }} />
//               <Box display="flex" justifyContent="space-between" sx={{ fontWeight: 'bold' }}>
//                 <Typography>Total Deductions:</Typography>
//                 <Typography>₹{existingPayroll.total_deductions}</Typography>
//               </Box>
//             </Grid>
//           </Grid>

//           <Box display="flex" justifyContent="space-between" mt={4}>
//             <Button
//               onClick={() => setIsPreview(false)}
//               variant="outlined"
//               color="secondary"
//               sx={{ width: '48%' }}
//             >
//               Cancel
//             </Button>
//             <Button
//               onClick={handleSubmit}
//               variant="contained"
//               color="primary"
//               sx={{ width: '48%' }}
//               disabled={isLoading}
//             >
//               {isLoading ? <CircularProgress size={24} /> : 'Generate Payslip'}
//             </Button>
//           </Box>
//         </StyledPaper>
//       );
//     }

//     return (
//       <>
//         {existingPayroll && renderPayrollDetails()}

//         <StyledPaper elevation={3} style={{ backgroundColor: "white", color: "black", padding: "16px", borderRadius: "8px" }}>
//           <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', color: "black" }}>
//             Earnings
//           </Typography>
//           {earnings.map((field, index) => (
//             <TextField
//               key={index}
//               label={field}
//               type="number"
//               variant="outlined"
//               fullWidth
//               margin="normal"
//               value={earningValues[field] || ""}
//               onChange={(e) => handleEarningChange(field, e.target.value)}
//               InputProps={{
//                 startAdornment: <Typography sx={{ mr: 1, color: "black" }}>₹</Typography>,
//                 style: { backgroundColor: "white", color: "black", borderRadius: "4px" }
//               }}
//               InputLabelProps={{
//                 style: { color: "red" }
//               }}
//               sx={{
//                 "& .MuiOutlinedInput-root": {
//                   "& fieldset": { borderColor: "#555" },
//                   "&:hover fieldset": { borderColor: "#777" },
//                   "&.Mui-focused fieldset": { borderColor: "#ffffff" },
//                 },
//               }}
//             />
//           ))}
//         </StyledPaper>

//         <StyledPaper elevation={3} style={{ backgroundColor: "white", color: "black", padding: "16px", borderRadius: "8px" }}>
//           <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold', color: "black" }}>
//             Deductions
//           </Typography>
//           {deductions
//             .filter(field => isPreview || field !== "LOP")
//             .map((field, index) => (
//               <TextField
//                 key={index}
//                 label={field}
//                 type="number"
//                 variant="outlined"
//                 fullWidth
//                 margin="normal"
//                 value={deductionValues[field] || ""}
//                 onChange={(e) => handleDeductionChange(field, e.target.value)}
//                 InputProps={{
//                   startAdornment: <Typography sx={{ mr: 1, color: "black" }}>₹</Typography>,
//                   style: { backgroundColor: "white", color: "black", borderRadius: "4px" }
//                 }}
//                 InputLabelProps={{
//                   style: { color: "red" }
//                 }}
//                 sx={{
//                   "& .MuiOutlinedInput-root": {
//                     "& fieldset": { borderColor: "#555" },
//                     "&:hover fieldset": { borderColor: "#777" },
//                     "&.Mui-focused fieldset": { borderColor: "#ffffff" },
//                   },
//                 }}
//               />
//             ))}
//         </StyledPaper>

//         <StyledButton
//           variant="contained"
//           color="primary"
//           fullWidth
//           onClick={handlePreview}
//           disabled={isLoading || !selectedEmployee || !selectedDate}
//           elevation={3}
//           style={{ backgroundColor: "white", color: "black", padding: "16px", borderRadius: "8px" }}
//         >
//           {isLoading ? <CircularProgress size={24} color="inherit" /> : 'Preview Payslip'}
//         </StyledButton>
//       </>
//     );
//   };

//   return (
//     <Box sx={{ maxWidth: 900, mx: 'auto', p: 3 }}>
//       <Typography variant="h4" align="center" gutterBottom sx={{ fontWeight: 'bold', color: 'white', mb: 4 }}>
//         Payroll Management
//       </Typography>

//       <StyledPaper elevation={3} style={{ backgroundColor: "white", color: "black", padding: "16px", borderRadius: "8px" }}>
//         <Grid container spacing={3}>
//           <Grid item xs={12} md={6}>
//             <TextField
//               label="Employee Email"
//               variant="outlined"
//               fullWidth
//               value={selectedEmployee}
//               InputProps={{
//                 readOnly: true,
//                 style: { color: "black", backgroundColor: "#f5f5f5" }
//               }}
//               InputLabelProps={{
//                 style: { color: "red" }
//               }}
//               sx={{
//                 "& .MuiOutlinedInput-root": {
//                   "& fieldset": { borderColor: "#555" },
//                   "&:hover fieldset": { borderColor: "#777" },
//                   "&.Mui-focused fieldset": { borderColor: "#ffffff" },
//                 },
//               }}
//             />
//           </Grid>
//           <Grid item xs={12} md={6}>
//             <TextField
//               label="Select Month"
//               type="month"
//               fullWidth
//               InputLabelProps={{ shrink: true, style: { color: "red" } }}
//               value={selectedDate}
//               onChange={(e) => {
//                 const selected = e.target.value;
//                 const currentDate = new Date();
//                 const currentYearMonth = `${currentDate.getFullYear()}-${String(currentDate.getMonth() + 1).padStart(2, '0')}`;

//                 if (selected <= currentYearMonth) {
//                   setSelectedDate(selected);
//                 }
//               }}
//               disabled={isLoading}
//               inputProps={{
//                 max: `${new Date().getFullYear()}-${String(new Date().getMonth() + 1).padStart(2, '0')}`
//               }}
//               sx={{
//                 backgroundColor: "white",
//                 color: "black",
//                 borderRadius: "4px",
//                 "& .MuiOutlinedInput-root": {
//                   "& fieldset": { borderColor: "black", color: "black" },
//                   "&:hover fieldset": { borderColor: "black" },
//                   "&.Mui-focused fieldset": { borderColor: "black" },
//                 },
//                 "& input": {
//                   color: "black",
//                 }
//               }}
//             />
//           </Grid>
//         </Grid>
//       </StyledPaper>

//       {renderPayrollForm()}
//     </Box>
//   );
// });

// export default Tab_PayrollPage;
import React, {
  forwardRef,
  useState,
  useEffect,
  useImperativeHandle,
} from "react";
import {
  Box,
  Grid,
  TextField,
  Paper,
  Typography,
  Divider,
  CircularProgress,
  useMediaQuery,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  Snackbar,
  Alert,
} from "@mui/material";
import { styled } from "@mui/system";
import { useTheme } from "@mui/material";
import { tokens } from "../../theme";
import Header from "../../components/Header";
import SaveIcon from "@mui/icons-material/Save";

const StyledPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(4),
  margin: theme.spacing(3, 0),
  borderRadius: theme.shape.borderRadius * 2,
  backgroundColor: theme.palette.mode === "dark" ? "#1F2A40" : "#F9FAFB",
  boxShadow: theme.shadows[5],
}));

const StyledTextField = styled(TextField)(({ theme }) => ({
  "& .MuiInputBase-root": {
    backgroundColor: theme.palette.background.paper,
    borderRadius: theme.shape.borderRadius,
  },
}));

const SectionTitle = styled(Typography)(({ theme }) => ({
  // color: theme.palette.mode === "dark" ? theme.palette.primary.light : theme.palette.primary.dark,
  fontWeight: 600,
  marginBottom: theme.spacing(2),
}));

const TotalRow = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "flex-end",
  alignItems: "center",
  padding: theme.spacing(2, 0),
  marginTop: theme.spacing(2),
  borderTop: `1px solid ${theme.palette.divider}`,
}));

const Tab_PayrollPage = forwardRef((props, ref) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const isSmallScreen = useMediaQuery("(max-width: 900px)");

  const { employeeId, externalState, setExternalState } = props;
  const [email, setEmail] = useState(employeeId || "");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [annualCTC, setAnnualCTC] = useState(0);
  const [isFetching, setIsFetching] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [payrollData, setPayrollData] = useState(null);
  const [ctcCategories, setCtcCategories] = useState({
    earnings: [],
    deductions: [],
  });
  const [earnings, setEarnings] = useState({});
  const [deductions, setDeductions] = useState({});
  const [payrollHistory, setPayrollHistory] = useState([]);
  const [isLoadingHistory, setIsLoadingHistory] = useState(false);
  const [monthlySalary, setMonthlySalary] = useState(0);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  const accessToken = JSON.parse(localStorage.getItem("emsUser"))?.user
    ?.stsTokenManager?.accessToken;
  // Expose functions and data to parent via ref
  useImperativeHandle(ref, () => ({
    savePayroll: handleSubmit,
    getPayrollData: () => ({
      earnings,
      deductions,
      startDate,
      endDate,
      annualCTC: calculateAnnualCTC(),
    }),
    isPayrollValid: () => email && startDate && endDate,
  }));

  // Calculate Annual CTC
  const calculateAnnualCTC = () => {
    const totalEarnings = Object.values(earnings).reduce(
      (acc, val) => acc + (val.amount_per_anum || 0),
      0
    );
    const totalDeductions = Object.values(deductions).reduce(
      (acc, val) => acc + (val.amount_per_anum || 0),
      0
    );
    return totalEarnings + totalDeductions;
  };

  // Calculate Monthly Salary (Net)
  const calculateMonthlySalary = () => {
    const totalMonthlyEarnings = Object.values(earnings).reduce(
      (acc, val) => acc + (val.amount_per_month || 0),
      0
    );
    const totalMonthlyDeductions = Object.values(deductions).reduce(
      (acc, val) => acc + (val.amount_per_month || 0),
      0
    );
    return totalMonthlyEarnings - totalMonthlyDeductions;
  };

  useEffect(() => {
    setAnnualCTC(calculateAnnualCTC());
    setMonthlySalary(calculateMonthlySalary());
  }, [earnings, deductions]);

  const mergePayrollWithCategories = (payrollData) => {
    const mergedEarnings = {};
    const mergedDeductions = {};

    ctcCategories.earnings?.forEach((category) => {
      if (payrollData?.earnings?.[category]) {
        mergedEarnings[category] = payrollData.earnings[category];
      } else {
        mergedEarnings[category] = {
          amount_per_anum: 0,
          amount_per_month: 0,
        };
      }
    });

    ctcCategories.deductions?.forEach((category) => {
      if (payrollData?.deductions?.[category]) {
        mergedDeductions[category] = payrollData.deductions[category];
      } else {
        mergedDeductions[category] = {
          amount_per_anum: 0,
          amount_per_month: 0,
        };
      }
    });

    return {
      ...payrollData,
      earnings: mergedEarnings,
      deductions: mergedDeductions,
    };
  };

  // Reset form to default values based on current ctcCategories
  const resetFormToDefaults = () => {
    const defaultEarnings = {};
    ctcCategories.earnings?.forEach((item) => {
      defaultEarnings[item] = {
        amount_per_anum: 0,
        amount_per_month: 0,
      };
    });

    const defaultDeductions = {};
    ctcCategories.deductions?.forEach((item) => {
      defaultDeductions[item] = {
        amount_per_anum: 0,
        amount_per_month: 0,
      };
    });

    setEarnings(defaultEarnings);
    setDeductions(defaultDeductions);
    setPayrollData(null);
  };

  // Fetch CTC categories structure
  useEffect(() => {
    const fetchCtcCategories = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BACKEND_URL_HRM}/get_ctc`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
          }
        );
        const data = await response.json();
        if (response.ok) {
          setCtcCategories(data);
          resetFormToDefaults();
        } else {
          console.error("Failed to fetch CTC categories:", data.error);
        }
      } catch (error) {
        console.error("Error fetching CTC categories:", error);
      }
    };

    fetchCtcCategories();
  }, []);

  const formatDateForAPI = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = String(date.getFullYear());
    return `${year}-${month}-${day}`;
  };

  // Fetch all payroll history for this employee
  useEffect(() => {
    const fetchPayrollHistory = async () => {
      if (!email) return;

      setIsLoadingHistory(true);
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BACKEND_URL_HRM}/get-payroll-history`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${accessToken}`,
            },
            body: JSON.stringify({ email_id: email }),
          }
        );

        const data = await response.json();

        if (response.ok) {
          setPayrollHistory(data.records || []);
        } else {
          console.error("Failed to fetch payroll history:", data.error);
          setPayrollHistory([]);
        }
      } catch (error) {
        console.error("Error fetching payroll history:", error);
        setPayrollHistory([]);
      } finally {
        setIsLoadingHistory(false);
      }
    };

    fetchPayrollHistory();
  }, [email]);

  // Fetch payroll data for specific period and merge with current CTC categories
  const fetchPayrollData = async () => {
    if (!email || !startDate || !endDate) return;

    const formattedStartDate = formatDateForAPI(startDate);
    const formattedEndDate = formatDateForAPI(endDate);

    setIsFetching(true);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL_HRM}/get-payroll-yearly`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
          body: JSON.stringify({
            email_id: email,
            start_date: formattedStartDate,
            end_date: formattedEndDate,
          }),
        }
      );

      const data = await response.json();

      if (response.ok) {
        if (
          data.message &&
          data.message.includes("No yearly payroll data found")
        ) {
          resetFormToDefaults();
        } else {
          const mergedData = mergePayrollWithCategories(data);
          setPayrollData(mergedData);
          setEarnings(mergedData.earnings || {});
          setDeductions(mergedData.deductions || {});
        }
      } else {
        console.error("Failed to fetch payroll data:", data.error);
        resetFormToDefaults();
      }
    } catch (error) {
      console.error("Error fetching payroll data:", error);
      resetFormToDefaults();
    } finally {
      setIsFetching(false);
    }
  };

  useEffect(() => {
    fetchPayrollData();
  }, [email, startDate, endDate, ctcCategories]);

  // Handle snackbar close
  const handleSnackbarClose = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  const handleSaveClick = async () => {
    if (!email || !startDate || !endDate) {
      setSnackbar({
        open: true,
        message: "Please fill in all required fields.",
        severity: "error",
      });
      return;
    }

    setIsSaving(true);
    try {
      const result = await handleSubmit();
      setSnackbar({
        open: true,
        message: "Payroll saved successfully!",
        severity: "success",
      });
    } catch (error) {
      setSnackbar({
        open: true,
        message: error.message || "Failed to save payroll.",
        severity: "error",
      });
    } finally {
      setIsSaving(false);
    }
  };

  const convertApiDateToInputFormat = (dateString) => {
    if (!dateString) return "";

    if (/^\d{4}-\d{2}-\d{2}$/.test(dateString)) {
      return dateString;
    }

    if (/^\d{2}-\d{2}-\d{2}$/.test(dateString)) {
      const [day, month, yearShort] = dateString.split("-");
      const fullYear = "20" + yearShort; 
      return `${fullYear}-${month}-${day}`;
    }

    try {
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return ""; 

      return date.toISOString().split("T")[0]; 
    } catch (error) {
      console.error("Error converting date:", error);
      return "";
    }
  };
  const handleSubmit = async () => {
    if (!email || !startDate || !endDate) {
      throw new Error("Please fill in all required fields.");
    }

    try {
      const formattedStartDate = formatDateForAPI(startDate);
      const formattedEndDate = formatDateForAPI(endDate);

      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL_HRM}/store-payroll-yearly`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
          body: JSON.stringify({
            email_id: email,
            start_date: formattedStartDate,
            end_date: formattedEndDate,
            earnings: earnings,
            deductions: deductions,
            total_earnings: Object.values(earnings).reduce(
              (acc, val) => acc + val.amount_per_anum,
              0
            ),
            total_deductions: Object.values(deductions).reduce(
              (acc, val) => acc + val.amount_per_anum,
              0
            ),
            total_salary:
              Object.values(earnings).reduce(
                (acc, val) => acc + val.amount_per_anum,
                0
              ) -
              Object.values(deductions).reduce(
                (acc, val) => acc + val.amount_per_anum,
                0
              ),
            annual_ctc: calculateAnnualCTC(),
          }),
        }
      );

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || "Failed to save payroll.");
      }

      // Refresh payroll history after saving
      const historyResponse = await fetch(
        `${process.env.REACT_APP_BACKEND_URL_HRM}/get-payroll-history`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
          body: JSON.stringify({ email_id: email }),
        }
      );

      if (historyResponse.ok) {
        const historyData = await historyResponse.json();
        setPayrollHistory(historyData.records || []);
      }

      return data;
    } catch (error) {
      console.error("Error saving payroll:", error);
      throw error;
    }
  };

  const loadPayrollRecord = (startDate, endDate) => {
    setStartDate(convertApiDateToInputFormat(startDate));
    setEndDate(convertApiDateToInputFormat(endDate));
  };

  const totalMonthlyEarnings = Object.values(earnings).reduce(
    (acc, val) => acc + (val.amount_per_month || 0),
    0
  );

  const totalMonthlyDeductions = Object.values(deductions).reduce(
    (acc, val) => acc + (val.amount_per_month || 0),
    0
  );

  const renderEarnings = () =>
    ctcCategories.earnings.map((key) => (
      <Grid container spacing={2} key={key} sx={{ mb: 2 }}>
        <Grid item xs={12} sm={4}>
          <Typography color={colors.grey[100]}>{key}</Typography>
        </Grid>
        <Grid item xs={12} sm={4}>
          <StyledTextField
            label="Amount Per Annum"
            type="number"
            // Use empty string when value is 0
            value={earnings[key]?.amount_per_anum || ""}
            onChange={(e) => {
              const value = e.target.value === "" ? "" : Number(e.target.value);
              setEarnings({
                ...earnings,
                [key]: {
                  ...earnings[key],
                  amount_per_anum: value,
                  // Only calculate if we have a valid number
                  amount_per_month:
                    value === "" ? "" : Math.round(Number(value) / 12),
                },
              });
            }}
            fullWidth
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <StyledTextField
            label="Amount Per Month"
            type="number"
            value={earnings[key]?.amount_per_month || ""}
            disabled
            fullWidth
          />
        </Grid>
      </Grid>
    ));

  const renderDeductions = () =>
    ctcCategories.deductions
      .filter((key) => key !== "LOP") // Filter out "LOP"
      .map((key) => (
        <Grid container spacing={2} key={key} sx={{ mb: 2 }}>
          <Grid item xs={12} sm={4}>
            <Typography color={colors.grey[100]}>{key}</Typography>
          </Grid>
          <Grid item xs={12} sm={4}>
            <StyledTextField
              label="Amount Per Annum"
              type="number"
              value={deductions[key]?.amount_per_anum || ""}
              onChange={(e) =>
                setDeductions({
                  ...deductions,
                  [key]: {
                    ...deductions[key],
                    amount_per_anum: Number(e.target.value),
                    amount_per_month: Math.round(Number(e.target.value) / 12),
                  },
                })
              }
              fullWidth
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <StyledTextField
              label="Amount Per Month"
              type="number"
              value={deductions[key]?.amount_per_month || ""}
              disabled
              fullWidth
            />
          </Grid>
        </Grid>
      ));

  useImperativeHandle(ref, () => ({
    update: async () => {
        const result = await handleSubmit(); 
        return result; 
    },
  }));

  return (
    <Box m={isSmallScreen ? 2 : 3}>
      <StyledPaper>
        <Typography variant="h5" gutterBottom color={colors.greenAccent[500]}>
          Payroll Management
        </Typography>
        <Divider sx={{ backgroundColor: colors.grey[700] }} />

        <Grid container spacing={2} mt={2}>
          <Grid item xs={12} sm={4}>
            <StyledTextField
              label="Employee Email"
              value={email}
              fullWidth
              disabled
              sx={{
                "& .MuiInputBase-root": {
                  color: colors.grey[100],
                },
              }}
            />
          </Grid>
          <Grid item xs={4}>
            <StyledTextField
              label="Start Date"
              type="date"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
              InputLabelProps={{
                shrink: true,
              }}
              fullWidth
            />
          </Grid>
          <Grid item xs={4}>
            <StyledTextField
              label="End Date"
              type="date"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
              InputLabelProps={{
                shrink: true,
              }}
              fullWidth
            />
          </Grid>
        </Grid>

        {/* Payroll History Section */}
        {email && (
          <Box mt={4}>
            <SectionTitle variant="h6">Payroll History</SectionTitle>
            {isLoadingHistory ? (
              <Box display="flex" justifyContent="center" mt={3}>
                <CircularProgress />
              </Box>
            ) : payrollHistory.length > 0 ? (
              <TableContainer
                component={Paper}
                sx={{ backgroundColor: colors.primary[400] }}
              >
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell
                        sx={{
                          fontWeight: "bold",
                          color: colors.greenAccent[500],
                        }}
                      >
                        Start Date
                      </TableCell>
                      <TableCell
                        sx={{
                          fontWeight: "bold",
                          color: colors.greenAccent[500],
                        }}
                      >
                        End Date
                      </TableCell>
                      <TableCell
                        sx={{
                          fontWeight: "bold",
                          color: colors.greenAccent[500],
                        }}
                      >
                        Annual CTC
                      </TableCell>
                      <TableCell
                        sx={{
                          fontWeight: "bold",
                          color: colors.greenAccent[500],
                        }}
                      >
                        Action
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {payrollHistory.map((record, index) => (
                      <TableRow
                        key={index}
                        hover
                        sx={{
                          "&:hover": {
                            backgroundColor: colors.primary[300],
                            cursor: "pointer",
                          },
                        }}
                      >
                        <TableCell>{record.start_date}</TableCell>
                        <TableCell>{record.end_date}</TableCell>
                        <TableCell>
                          {record.annual_ctc?.toLocaleString() || 0}
                        </TableCell>
                        <TableCell>
                          <Typography
                            color={colors.blueAccent[400]}
                            sx={{
                              cursor: "pointer",
                              "&:hover": { textDecoration: "underline" },
                            }}
                            onClick={() =>
                              loadPayrollRecord(
                                record.start_date,
                                record.end_date
                              )
                            }
                          >
                            Load
                          </Typography>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            ) : (
              <Typography color={colors.grey[300]}>
                No payroll history found for this employee.
              </Typography>
            )}
          </Box>
        )}

        {isFetching && (
          <Box display="flex" justifyContent="center" mt={3}>
            <CircularProgress />
          </Box>
        )}

        <Box mt={4}>
          <SectionTitle variant="h6">Earnings</SectionTitle>
          {renderEarnings()}

          {/* Total Monthly Earnings */}
          <TotalRow>
            <Grid container justifyContent="flex-end" alignItems="center">
              <Grid item xs={12} sm={4}>
                <Typography
                  variant="subtitle1"
                  fontWeight="bold"
                  color={colors.greenAccent[500]}
                >
                  Total Monthly Earnings
                </Typography>
              </Grid>
              <Grid item xs={12} sm={4}>
                {/* Empty grid for spacing */}
              </Grid>
              <Grid item xs={12} sm={4}>
                <StyledTextField
                  label="Monthly Total"
                  type="number"
                  value={totalMonthlyEarnings || 0}
                  disabled
                  fullWidth
                  InputProps={{
                    sx: { fontWeight: "bold", color: colors.greenAccent[400] },
                  }}
                />
              </Grid>
            </Grid>
          </TotalRow>
        </Box>

        <Box mt={4}>
          <SectionTitle variant="h6">Deductions</SectionTitle>
          {renderDeductions()}

          {/* Total Monthly Deductions */}
          <TotalRow>
            <Grid container justifyContent="flex-end" alignItems="center">
              <Grid item xs={12} sm={4}>
                <Typography
                  variant="subtitle1"
                  fontWeight="bold"
                  color={colors.greenAccent[500]}
                >
                  Total Monthly Deductions
                </Typography>
              </Grid>
              <Grid item xs={12} sm={4}>
                {/* Empty grid for spacing */}
              </Grid>
              <Grid item xs={12} sm={4}>
                <StyledTextField
                  label="Monthly Total"
                  type="number"
                  value={totalMonthlyDeductions || 0}
                  disabled
                  fullWidth
                  InputProps={{
                    sx: { fontWeight: "bold", color: colors.greenAccent[400] },
                  }}
                />
              </Grid>
            </Grid>
          </TotalRow>
        </Box>

        <Box mt={4}>
          <SectionTitle variant="h6">Salary Summary</SectionTitle>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <StyledTextField
                label="ANNUAL CTC"
                type="number"
                value={annualCTC || 0}
                disabled
                fullWidth
                InputProps={{
                  sx: { fontWeight: "bold" },
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <StyledTextField
                label="NET MONTHLY SALARY"
                type="number"
                value={monthlySalary || 0}
                disabled
                fullWidth
                InputProps={{
                  sx: { fontWeight: "bold", color: colors.greenAccent[400] },
                }}
              />
            </Grid>
          </Grid>
        </Box>

        {/* Save Button */}
        <Box mt={4} display="flex" justifyContent="flex-end">
          <Button
            variant="contained"
            color="primary"
            startIcon={<SaveIcon />}
            onClick={handleSaveClick}
            disabled={isSaving || !email || !startDate || !endDate}
            sx={{
              backgroundColor: colors.greenAccent[600],
              "&:hover": {
                backgroundColor: colors.greenAccent[700],
              },
              fontSize: "16px",
              fontWeight: "bold",
              padding: "10px 24px",
            }}
          >
            {isSaving ? "Saving..." : "Save Payroll"}
          </Button>
        </Box>

        {/* Snackbar for notifications */}
        <Snackbar
          open={snackbar.open}
          autoHideDuration={6000}
          onClose={handleSnackbarClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        >
          <Alert
            onClose={handleSnackbarClose}
            severity={snackbar.severity}
            sx={{ width: "100%" }}
          >
            {snackbar.message}
          </Alert>
        </Snackbar>
      </StyledPaper>
    </Box>
  );
});

export default Tab_PayrollPage;
